import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { RegexpTypes, required, email } from "@bappweb/utils"
import {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useApply1Mutation
} from "../../../api/services"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"

type PropsType = {
  onError?: (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => void
  onSubmit?: (event?: React.BaseSyntheticEvent, values?: Record<string, any>) => void
}

function MainForm({ onError, onSubmit }: PropsType) {
  const history = useHistory()

  const [formValues, setFormValues] = useState({
    nameSurname: "",
    phone: "",
    email: "",
    mbb: "",
    isForgetMbb: false
  })

  const [isCustomer, setisCustomer] = useState("H")

  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    guid: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)
  const [showMbbField, setShowMbbField] = useState(false)
  const refForm = useRef(null)
  const [getTokenByTckn1] = useGetTokenByTckn1Mutation()

  const handleNameBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const { value } = e.target
      if ((value ?? "").length > 5 && value.length <= 100) {
        setIsFetching(true)
        getTokenByTckn1(value + "ABCABCABC")
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError("")
              setCaptchaValues({
                ...captchaValues,
                tokenSessionId: payload.tokenSessionId,
                guid: value + "ABCABCABC"
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [getTokenByTckn1, captchaValues]
  )

  const handleIsForgetMbbChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.target

      setFormValues({
        ...formValues,
        isForgetMbb: checked
      })
    },
    [formValues]
  )

  const handleChange = useCallback(
    (e) => {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case "name":
          setError(null)
          setFormValues({
            ...formValues,
            nameSurname: value
          })
          setCaptchaValues({
            ...captchaValues,
            captchaData: "",
            tokenSessionId: "",
            showCaptcha: false
          })

          // @ts-ignore TODO
          // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
          refForm.current?.setValue("captcha", "")

          break
        case "phone":
          setError(null)
          setFormValues({
            ...formValues,
            phone: value
          })
          break
        case "email":
          setError(null)
          setFormValues({
            ...formValues,
            email: value
          })
          break
        case "isCustomer":
          setisCustomer(value)
          if (value === "E") {
            setShowMbbField(true)
          } else if (value === "H") {
            setShowMbbField(false)
          }
          break
        case "mbb":
          setFormValues({
            ...formValues,
            mbb: value
          })
          break
        case "captcha":
          setError(null)
          setCaptchaValues({
            ...captchaValues,
            captcha: value
          })
          break
        default:
          break
      }
    },
    [formValues, captchaValues]
  )

  const [getCaptcha] = useGetCaptchaMutation()
  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        guid: captchaValues.guid,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setCaptchaValues({
              ...captchaValues,
              captchaData: payload.captchaData,
              showCaptcha: true,
              captchaValidate: true
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => {
          setIsFetching(false)
        })
    }
  }, [getCaptcha, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation()
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      guid: captchaValues.guid,
      TokenSessionId: captchaValues.tokenSessionId
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [captchaValues, refreshCaptcha])

  const [apply1] = useApply1Mutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && captchaValues.captcha !== "") {
        setIsFetching(true)
        apply1({
          guid: captchaValues.guid,
          nameSurname: formValues.nameSurname,
          phone: formValues.phone.replace(/\s/g, ""),
          email: formValues.email,
          isCustomer: isCustomer,
          mbbNo: formValues.mbb,
          forgetMbbNo: formValues.isForgetMbb,
          captcha: captchaValues.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          TokenSessionId: captchaValues.tokenSessionId
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              history.push({
                pathname: "/result/success",
                state: payload
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0
              })
              refreshCaptcha({
                guid: captchaValues.guid,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  } else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => {
                  setIsFetching(false)
                })
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [captchaValues, formValues, isCustomer, apply1, refreshCaptcha, history]
  )

  return (
    <Page>
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false} ref={refForm}>
        <Panel hasFooter connected={false} loading={isFetching}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-title">
              En İyi Finansal Çözümlerle Özel Bankacılık Başvurusu
            </Element>
            <TextField
              label="Adınız Soyadınız"
              type="text"
              name="name"
              placeholder="Adınız Soyadınız"
              maxLength={100}
              onBlur={handleNameBlur}
              value={formValues.nameSurname}
              validator={RegexpTypes.AlphaTr}
              validations={[required("Bu alan zorunludur.")]}
            />
            <TextField
              label="Cep Telefon No"
              type="text"
              name="phone"
              placeholder="5__ ___ __ __"
              mask="999 999 99 99"
              maxLength={13}
              value={formValues.phone}
              getMaskedValue={true}
              validations={[required("Bu alan zorunludur.")]}
            />
            <TextField
              type="text"
              name="email"
              label="E-Posta Adresiniz"
              placeholder="E-Posta Adresiniz"
              maxLength={150}
              validations={[
                required("Bu alan zorunludur."),
                email("Lütfen geçerli bir e-posta adresi giriniz.")
              ]}
            />
            <RadioGroup
              label="Akbank müşterisi misiniz?"
              name="isCustomer"
              value={isCustomer}
              block={false}
              validations={[required("Lütfen seçim yapınız.")]}>
              <Radio label="Evet" name="yes" value="E" />
              <Radio label="Hayır" name="no" value="H" />
            </RadioGroup>
            {showMbbField && (
              <React.Fragment>
                {!formValues.isForgetMbb && (
                  <TextField
                    label="Müşteri Numaranız"
                    type="number"
                    name="mbb"
                    placeholder="Müşteri Numaranız"
                    maxLength={10}
                    value={formValues.mbb}
                    validator={RegexpTypes.Numeric}
                    validations={[required("Bu alan zorunludur.")]}
                  />
                )}
                <div className="checkbox-group">
                  <Checkbox
                    className="cb-position-fix"
                    name="isForgetMbb"
                    validateOnSubmit={true}
                    onChange={handleIsForgetMbbChange}
                    block>
                    {"Müşteri numaramı hatırlamıyorum"}
                  </Checkbox>
                </div>
              </React.Fragment>
            )}
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
                validateCaptcha={captchaValues.captchaValidate}
              />
            )}
            <div className="checkbox-group">
              <Checkbox
                className="cb-position-fix"
                name="checkboxKvkk"
                validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                validateOnSubmit={true}
                block>
                {
                  "AKBANK T.A.Ş. olarak kişisel verilerini önemsiyoruz. 6698 nolu Kişisel Verilerin Korunması Kanunu kapsamında kişisel verilerinin işlenmesinden doğan haklarına ve bu konudaki detaylı bilgiye "
                }
                <Link
                  href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                  text={" aydınlatma metninden"}
                  inline
                  target="_blank"
                />
                {" ulaşabilirsiniz."}
              </Checkbox>
            </div>
          </Panel.Body>
          <Panel.Footer>
            <Panel.RightFooter>
              <Button text="DEVAM" type="submit" fetching={isFetching} disabled={isFetching} />
            </Panel.RightFooter>
          </Panel.Footer>
        </Panel>
      </Form>
    </Page>
  )
}

export default MainForm
